import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DetailTitleViewModel } from 'app/request-form/_models/detail-title.view-model';

@Component({
  selector: 'app-detail-title',
  templateUrl: './detail-title.component.html',
  styleUrls: ['./detail-title.component.scss'],
  standalone: false,
})
export class DetailTitleComponent implements OnInit {
  @Input() viewModel: DetailTitleViewModel;
  @Output() updateAction = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  clickLink(): void {
    this.updateAction.emit();
  }
}
